import React, { Fragment } from 'react'

const Affirm = ({ product }) => {
    const firstVariantWithInventory = product?.variants.find(
        (variant) => variant.inventory_quantity > 0
    )

    const price = firstVariantWithInventory?.price
    const compareAtPrice = firstVariantWithInventory?.compare_at_price

    const vendor = product?.vendor

    return (
        <Fragment>
            {vendor === 'Monica + Andy' && product ? (
                <div className="afterpay-messaging !text-xs !font-normal top-2 w-full">
                    <square-placement
                        data-mpid="3d7b31a3-59fb-465b-bb70-6c38f4f2f952"
                        data-placement-id="ad537775-3d6c-4235-8f2c-af51f7cb5fd2"
                        data-page-type="product"
                        data-amount={
                            price?.compareAtPrice
                                ? parseFloat(price?.compareAtPrice).toFixed(2)
                                : parseFloat(price?.price).toFixed(2)
                        }
                        data-currency="USD"
                        data-consumer-locale="US"
                        data-item-skus={
                            firstVariantWithInventory &&
                            firstVariantWithInventory.sku
                                ? firstVariantWithInventory.sku
                                : ''
                        }
                        data-item-categories={
                            product && product.product_type
                                ? product.product_type
                                : ''
                        }
                        data-is-eligible="true"
                    ></square-placement>
                </div>
            ) : null}
        </Fragment>
    )
}
export default Affirm
